module.exports = __webpack_public_path__ + "img/b6d13a2.svg";